import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CategoriesService } from '../../../services/categories.service';
import { ModalData } from '../../../models/modal-data.model';

@Component({
  selector: 'app-modal-delete',
  templateUrl: './modal-delete.component.html',
  styleUrls: ['./modal-delete.component.scss'],
})
export class ModalDeleteComponent implements OnInit {
  @Input() modalData: ModalData;
  modalRef: BsModalRef;
  inOnDeleting: boolean = false;
  constructor(
    private modalService: BsModalService,
    private categoriesService: CategoriesService
  ) {}

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  ngOnInit() {
    this.modalService.onHide.subscribe(() => {
      this.inOnDeleting = false;
    });
  }

  delete() {
    if (this.inOnDeleting) {
      return;
    }
    this.inOnDeleting = true;
    if (!this.modalData || isNaN(this.modalData.id)) {
      return;
    }
    this.categoriesService.delete(this.modalData.id).subscribe((x) => {
      this.inOnDeleting = false;
      this.modalRef.hide();
      this.categoriesService.deleteCategoryClicked();
    });
  }
}
